
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.454 64.558"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.454 34.415c0-7.363-5.797-13.125-13.278-15.102a21.568 21.568 0 012.491.515C47.617 8.305 36.318 0 23.835 0 11.246 0-.002 8.405 0 19.909A17.564 17.564 0 004.064 31.1c.112 3.64-2.026 8.86-3.96 12.662 5.169-.93 12.52-2.998 15.85-5.041a35.047 35.047 0 005.554.891c-.019-.104-.027-.194-.044-.295.054.136.112.271.17.407.983-1.139 2.735-1.961 5.822-2.056a9.637 9.637 0 015.357-1.369c3.27 0 4.898 1.432 5.687 2.633 1.633 2.497.611 4.216-.138 5.018l-.358.358-.094 1.913a2.667 2.667 0 011.283 2.617l-.168 1.337c.107.002.208.014.316.014a27.12 27.12 0 006.414-.794c2.65 1.626 8.502 3.266 12.615 4.014-1.536-3.026-3.238-7.182-3.154-10.084a13.973 13.973 0 003.238-8.91zm-37.948 0c0 .095.015.189.017.284a37.897 37.897 0 01-5.37-1.079 23.855 23.855 0 01-7.17 3.275 20.535 20.535 0 00.794-7.587c-1.988-2.384-4.012-4.935-4.012-9.4 0-8.347 8.555-15.14 19.07-15.14 10.057 0 18.281 6.219 18.983 14.062a22.413 22.413 0 00-3.338-.261c-9.96 0-18.974 6.646-18.974 15.846z"}}),_c('path',{staticClass:"user",attrs:{"d":"M37.533 57.402l-3.718-.93-.206-.824a7.722 7.722 0 001.916-3.794 2.05 2.05 0 001.18-1.606l.262-2.09a2.042 2.042 0 00-.982-2.004l.072-1.464.274-.274a2.879 2.879 0 00.106-3.842 4.826 4.826 0 00-4.354-2.016 7.38 7.38 0 00-4.102 1.048c-4.76.146-5.38 2.55-5.38 4.646 0 .414.08 1.228.15 1.864a2.052 2.052 0 00-1.04 2.044l.262 2.086a1.998 1.998 0 001.304 1.632 7.773 7.773 0 001.816 3.672l-.23.922-3.718.93a6.334 6.334 0 00-4.808 6.156 1 1 0 001 1h24a1.002 1.002 0 001-1.002 6.332 6.332 0 00-4.804-6.154z"}})])
          )
        }
      }
    